export default __webpack_public_path__ + "static/media/veg_Unlocked.fbae5911.png";